















































import { UserRights } from "@/configuration/authentication";
import { Zone } from "@/model/Zone";
import { RoleSetting } from "@/model/user/RoleSetting";
import { UserDetailsResponse } from "@/model/user/UserDetailsResponse";
import { Component, Prop, Vue } from "vue-property-decorator";
import ConfirmDialog from "@/components/ConfirmDialog.vue";


@Component({ components : { ConfirmDialog }})
export default class UsersRightsManagement extends Vue {

    @Prop({ default: [] }) allZones: Zone[];
    @Prop({ default: null }) connectedUser: UserRights;
    @Prop({ default: null }) userDetails: UserDetailsResponse;
    @Prop({ default: {} }) rolesUser: { [key: string]: string };
    rolesSettings: RoleSetting[] = [
        { label: 'Aucun', enumRole: null , canChange : ['CENTRAL_ADMIN', 'STORE_ADMIN', 'MANAGER']},
        { label: 'Préparateur', enumRole: 'USER', canChange : ['CENTRAL_ADMIN', 'STORE_ADMIN', 'MANAGER']},
        { label: 'Manager', enumRole: 'MANAGER', canChange : ['CENTRAL_ADMIN', 'STORE_ADMIN', 'MANAGER']},
        { label: 'Admin', enumRole: 'STORE_ADMIN', canChange : ['CENTRAL_ADMIN', 'STORE_ADMIN']}
    ];
    
    isDialogOpen: boolean = false;
    dialogText: string = "Êtes-vous sûr de vouloir modifier les droits de l'utilisateur ?";
    dialogTitle: string = "Modification des droits";

    back() {
        this.$emit('back');
    }

    save() {
        this.isDialogOpen = true;
    }

    canceledSave(){
        this.isDialogOpen = false;
    }

    confirmedSave(){
        this.isDialogOpen = false;
        this.$emit('save', this.rolesUser);
    }

    disableZone(zone: Zone) {
        if(this.connectedUser.zonesAccreditations.some(x => x.role === "CENTRAL_ADMIN" || x.role === "STORE_ADMIN")) {
            return false;
        }

        if(this.connectedUser.zonesAccreditations.some(x => x.role === "MANAGER" && x.zone === zone.zoneCode)){
          return false;
        }

        return true;
    }

    isDisplayable(zone: Zone, role: RoleSetting): boolean {
        return role.canChange.includes(this.connectedUser.role)
    }
}
